import React, { useState } from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { editDeviceApi, setDevInputsApi, deleteDevApi } from '../api/api';
import Modal from '../components/Modal';
import ConfirmAlert from '../components/ConfirmAlert';
import AlertAccent from '../components/AlertErrorBox';
import AnyDeviceEditor from './AnyDeviceEditor';
import ControllerEditor from './ControllerEditor';
import DeviceCard from './DeviceCard';
import DeviceNames from './DeviceNames';
import { empty } from '../regex';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import { useThresholdStore } from '../features/Devices/threshold';
import { useWaterTariffStore } from '../features/Devices/waterTariffs/use-water-tariff-store';
import { ERROR_TEXT, validationRules } from '../constants';
import { useDevicesStore } from '../stores';
import ChangeCounter from '../features/Devices/counter/ChangeCounter';
import Tooltip from '../components/Tooltip';

const EditMenu = ({ device, timeZone }) => {
  const [showEditModal, setShowEditModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [showChangeDeviceModal, setChangeDeviceModal] = useState(false);
  const [deviceError, setDeviceError] = useState([]);
  const { updateThreshold } = useThresholdStore();
  const { updateWaterTariffs } = useWaterTariffStore();
  const { devices, getGroupDevices } = useDevicesStore();
  const isCounter = device?.type?.key === 'counter';

  const editDev = async () => {
    if (device.type.key === 'controller') {
      await setDevInputs();
    }

    if (validateDeviceToEdit()) {
      await editDevice();
      await getGroupDevices();
    }
  };

  const [deviceToEdit, setDeviceToEdit] = useState(device);
  const editDevice = async () => {
    setDeviceError([]);
    await editDeviceApi(
      deviceToEdit,
      (data) => {
        setDeviceError([]);
      },
      (err) => {
        toast.error(err.error, { hideProgressBar: true });
        setDeviceError((p) => [...p, err]);
      }
    );
    if (device.type.key === 'counter') {
      await updateThreshold(deviceToEdit.id);
      await updateWaterTariffs(deviceToEdit.id);
    }
    setShowEditModal(false);
  };

  const validateDeviceToEdit = () => {
    let ret = true;
    if (empty.test(deviceToEdit.serial_number)) {
      setDeviceError((p) => [...p, { error: ERROR_TEXT.SERIAL_NUMBER_EMPTY }]);
      ret = false;
    }
    if (deviceToEdit?.type?.key === 'controller' && deviceToEdit.serial_number.length !== validationRules.SERIAL_NUMBER_LENGTH) {
      setDeviceError((prev) => [...prev, { error: ERROR_TEXT.SERIAL_NUMBER_LENGTH }]);
      ret = false;
    }
    if (empty.test(deviceToEdit.description)) {
      setDeviceError((p) => [...p, { error: 'Заполните место установки' }]);
      ret = false;
    }

    return ret;
  };

  const openEditModal = async () => {
    setDeviceToEdit(device);
    setDeviceError([]);
    setShowEditModal(true);
  };

  const [deviceInputs, setDeviceInputs] = useState(device.children);

  const setDevInputs = async () => {
    setDeviceError([]);

    await setDevInputsApi(
      deviceToEdit.id,
      deviceInputs,
      (data) => {},
      (err) => {
        toast.error(err.error, { hideProgressBar: true });
        setDeviceError((p) => [...p, err]);
      }
    );
  };

  const deleteDev = async () => {
    await deleteDevApi(
      device.id,
      (data) => {
        setShowAlert(false);
      },
      (err) => {
        toast.error(err.error, { hideProgressBar: true });
      }
    );
  };

  const deleteConfirmed = async () => {
    await deleteDev();
    await getGroupDevices();
  };

  const toolbar = [
    {
      onClick: () => setShowModal(true),
      Icon: InfoOutlinedIcon,
      toolTip: 'Информация об устройстве',
    },
    {
      onClick: () => openEditModal(),
      Icon: ModeEditOutlineOutlinedIcon,
      toolTip: 'Редактирование',
    },
    {
      onClick: () => setShowAlert(true),
      Icon: DeleteForeverOutlinedIcon,
      toolTip: 'Удаление',
    },
    {
      onClick: () => setChangeDeviceModal(true),
      Icon: SwapHorizIcon,
      hideButton: !isCounter,
      toolTip: 'Замена счетчика',
    },
  ];

  return (
    <>
      <div className={'flex gap-2'}>
        {toolbar.map(
          ({ onClick, Icon, hideButton, toolTip }, index) =>
            !hideButton && (
              <div
                key={index}
                onClick={onClick}
                className="cursor-pointer flex items-center justify-center bg-orange-500 hover:bg-orange-600 rounded-full w-8 h-8">
                <Tooltip color={'text-gray-500'} className={'flex'} text={toolTip}>
                  <Icon className="text-white w-6 h-6" />
                </Tooltip>
              </div>
            )
        )}
      </div>

      <ConfirmAlert showAlert={showAlert} setShowAlert={setShowAlert} delCb={deleteConfirmed} title="Удаление устройства">
        <AlertAccent text="Вы действительно хотите удалить устройство?" showAlert={true}>
          <DeviceNames device={device} style="line-clamp-1" />
        </AlertAccent>
      </ConfirmAlert>

      <Modal showModal={showEditModal} setShowModal={setShowEditModal} saveCb={editDev} title="Редактирование устройства" error={deviceError} style={1}>
        {device.type.key === 'controller' ? (
          <ControllerEditor
            setDeviceToEdit={setDeviceToEdit}
            deviceToEdit={deviceToEdit}
            devices={devices}
            deviceInputs={deviceInputs}
            setDeviceInputs={setDeviceInputs}
          />
        ) : (
          <AnyDeviceEditor setDeviceToEdit={setDeviceToEdit} deviceToEdit={deviceToEdit} />
        )}
      </Modal>

      <Modal showModal={showModal} setShowModal={setShowModal} title="Карточка устройства">
        <DeviceCard device={device} timeZone={timeZone} />
      </Modal>
      <ChangeCounter device={device} showModal={showChangeDeviceModal} setShowModal={setChangeDeviceModal} />
    </>
  );
};

export default EditMenu;
